import { nameof } from '../../../lib/name-of';
import { useContextOrThrow } from '../../../lib/use-context-or-throw';
import { ClientContext } from './ClientContext';

export const useSecurityDb = () => {
  const client = useContextOrThrow(ClientContext, nameof({ ClientContext }));

  return client.databases.security;
};
